/* @ngInject */
const sterileGo = (
  $state,
  routes,
  wagonLocal
) => {
  const self = {}

  self.edit = (_id) => {
    wagonLocal.saveCurrentScrappedId(_id)
    $state.go(routes.scrapping.sale.steriles.path)
  }

  return self
}
export default sterileGo



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sterile/services/go.service.js